class WishlistGrid extends HTMLElement {
  connectedCallback () {
    this.emptyEl = this.querySelector('[data-wishlist-grid-el="empty"]')
    this.gridEl = this.querySelector('[data-wishlist-grid-el="grid"]')

    this.initialise()
  }

  async initialise () {
    await window.theme.wishlist.readyPromise

    const urlParams = new URLSearchParams(window.location.search)
    const sharedWishlistId = urlParams.get('lid')

    if (sharedWishlistId) {
      await this.showSharedWishlist(sharedWishlistId)
    } else {
      await this.showUserWishlist()
    }
  }

  async showSharedWishlist (lid) {
    try {
      const wishlist = await window.theme.wishlist.fetchWishlist(lid)

      if (wishlist && wishlist.items && wishlist.items.length > 0) {
        this.showWishlistContent(wishlist, true)
        this.dataset.wishlistId = lid
      } else {
        this.showEmptyView()
      }
    } catch (error) {
      console.error('Error loading shared wishlist:', error)
      this.showEmptyView()
    }
  }

  async showUserWishlist () {
    try {
      await window.theme.wishlist.wishlistPromise
      const wishlist = await window.theme.wishlist.fetchWishlist()

      if (wishlist && wishlist.items && wishlist.items.length > 0) {
        this.showWishlistContent(wishlist, false)
        this.dataset.wishlistId = wishlist.list.lid
      } else {
        this.showEmptyView()
      }
    } catch (error) {
      console.error('Error loading user wishlist:', error)
      this.showEmptyView()
    }
  }

  async showWishlistContent (wishlist, isShared) {
    if (isShared && wishlist.list) {
      wishlist = wishlist.list
    }

    await this.generateProductGrid(wishlist)

    this.gridEl.setAttribute('aria-hidden', 'false')
    this.emptyEl.setAttribute('aria-hidden', 'true')
  }

  showEmptyView () {
    this.gridEl.innerHTML = ''

    this.gridEl.setAttribute('aria-hidden', 'true')
    this.emptyEl.setAttribute('aria-hidden', 'false')
  }

  async generateProductGrid (wishlist) {
    const productCards = await Promise.all(
      wishlist.items.map(async product => {
        const cardEl = document.createElement('li')
        const cardHtml = await this.fetchProductCard(product)

        cardEl.classList.add('pg-wishlist__product')
        cardEl.innerHTML = cardHtml

        const deleteButton = document.createElement('button')
        deleteButton.classList.add('pg-wishlist__delete-product')
        deleteButton.innerHTML = '<span class="sr-only">Remove</span>'

        cardEl.appendChild(deleteButton)

        deleteButton.addEventListener('click', () => {
          const event = new CustomEvent(window.theme.wishlist.eventBus.wishlist_remove_product, {
            detail: {
              productId: product.empi,
              variantId: product.epi,
              productUrl: product.du,
            },
          })

          window.dispatchEvent(event)

          deleteButton.closest('li').remove()
        })

        return cardEl
      }),
    )

    this.gridEl.innerHTML = ''
    productCards.forEach(cardEl => {
      this.gridEl.appendChild(cardEl)
    })
  }

  async fetchProductCard (product) {
    const { du: productUrl, epi: variantId } = product
    const handle = productUrl.split('products/')[1]
    const handleWithoutVariant = handle.split('?')[0]
    const getActiveMarket = document.querySelector('body').dataset.activeMarket

    return fetch(
      `${getActiveMarket}products/${handleWithoutVariant}?section_id=product-card&variant=${variantId}`,
    )
      .then(res => res.text())
      .then(html => {
        return html
      })
      .catch(e => {
        console.error(e)
      })
  }
}

customElements.define('wishlist-grid', WishlistGrid)
